import { StyleSheet, Platform } from "react-native";
import theme from "../theme";
import { dynamicSize } from "../helpers";

export default StyleSheet.create({
	input:
		Platform.OS == "web"
			? {
					borderBottomColor: "#0e0b09",
					borderBottomWidth: 1,
			  }
			: {
					borderBottomColor: theme.colors.inputBorder,
					paddingVertical: dynamicSize(13),
					height: dynamicSize(50),
			  },
	textarea:
		Platform.OS == "web"
			? {
					borderBottomColor: "#0e0b09",
					borderBottomWidth: 1,
					height: dynamicSize(120),
			  }
			: {
					borderColor: theme.colors.inputBorder,
					padding: dynamicSize(10),
					height: dynamicSize(100),
					borderWidth: 1,
					marginTop: dynamicSize(13),
					textAlignVertical: "top", // android only
			  },

	row: {
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "flex-start",
	},
	smallCheckboxIcon: {
		width: dynamicSize(16),
		height: dynamicSize(16),
		marginRight: dynamicSize(8),
	},
	checkboxIcon: {
		width: dynamicSize(20),
		height: dynamicSize(20),
		marginRight: dynamicSize(10),
	},
	checkboxRow: {
		backgroundColor: "transparent",
		borderBottomWidth: 0,
	},
	group:
		Platform.OS === "web"
			? {
					marginBottom: 22,
			  }
			: {
					marginBottom: dynamicSize(24),
			  },
	space: {
		width: dynamicSize(6),
		flex: 0,
	},
	button: {
		borderRadius: dynamicSize(2),
		paddingVertical: dynamicSize(14),
		justifyContent: "center",
		alignItems: "center",
		flexDirection: "row",
	},
	buttonImage: {
		width: dynamicSize(8),
		height: dynamicSize(13),
		marginLeft: dynamicSize(24),
	},
	actionSpace: {
		height: dynamicSize(12),
	},
	icon: {
		position: "absolute",
		bottom: dynamicSize(14),
		width: dynamicSize(22),
		height: dynamicSize(22),
		right: 0,
	},
	pickerViewContainer: {
		borderBottomColor: theme.colors.inputBorder,
		borderBottomWidth: 1,
		height: dynamicSize(50),
	},
	pickerChevronContainer: {
		opacity: 0,
	},
	pickerIcon: {
		borderTopWidth: dynamicSize(12),
		borderTopColor: theme.colors.grey8,
		borderRightWidth: dynamicSize(6),
		borderLeftWidth: dynamicSize(6),
		top: "auto",
		bottom: dynamicSize(16),
		right: 0,
	},
	pickerDone: {
		color: theme.colors.orange,
		fontWeight: "normal",
		fontSize: dynamicSize(18),
	},
	pickerModalViewMiddle: {
		backgroundColor: "rgba(246,246,246,.9)",
		borderTopWidth: 0,
		shadowColor: "rgba(0,0,0,.3)",
		shadowOffset: {
			width: 0,
			height: 1,
		},
		shadowOpacity: 0.3,
		shadowRadius: 0,
		elevation: 1,
		alignItems: "center",
	},
	pickerModalViewBottom: {
		backgroundColor: theme.colors.white,
	},
	section: {
		padding: dynamicSize(15),
		paddingBottom: 0,
		marginTop: dynamicSize(10),
		borderColor: theme.colors.grey3,
		borderWidth: 1,
	},
	invalidInput: {
		borderColor: theme.errorColor,
		borderBottomColor: theme.errorColor,
		borderBottomWidth: 1,
	},
});
